import { AxiosResponse } from 'axios'

import { User } from '../interfaces/User.interface'
import { UserAuthority } from '../interfaces/UserAuthority.interface'

import { employeesApi } from './'

export const getUsers = () => (
  employeesApi.get<User[]>('/user/admin')
    .then((response: AxiosResponse) => response.data)
)

export const getAllLocations = () => (
  employeesApi.get<Location[]>('/location/all')
    .then((response: AxiosResponse) => response.data)
)

export const getAllRoles = () => (
  employeesApi.get<UserAuthority[]>('/user/admin/role')
    .then((response: AxiosResponse) => response.data)
)

export const addUserRole = (userId: number, role: string) => (
  employeesApi.put<User>(`/user/admin/${userId}/role/${role}`)
    .then((response: AxiosResponse) => response.data)
)

export const deleteUserRole = (userId: number, role: string) => (
  employeesApi.delete(`/user/admin/${userId}/role/${role}`)
    .then((response: AxiosResponse) => response.data)
)

export const addUserLocation = (userId: number, locationId: number) => (
  employeesApi.put<User>(`/user/admin/${userId}/location/${locationId}`)
    .then((response: AxiosResponse) => response.data)
)

export const deleteUserLocation = (userId: number, locationId: number) => (
  employeesApi.delete(`/user/admin/${userId}/location/${locationId}`)
    .then((response: AxiosResponse) => response.data)
)



// WEBPACK FOOTER //
// ./src/lib/api/admin.ts